import React from "react";
import SearchBasePage from "./SearchBasePage";
import {useSearchParams} from "react-router-dom";
import {Helmet} from "react-helmet-async";
import {updateStatesOrLink} from "../commons/Utils/LinkParamUtils";
import EiaShareButton from "../components/EiaShareButton";

const SearchPage = function (props) {
    const {user} = props;

    const [baseItem, setBaseItem] = React.useState({});
    const baseItemFieldsForLink = [
        {name: 'itemType', linkParam: 'item_type'},
        {name: 'itemSubType', linkParam: 'item_sub_type'},
        {name: 'name', linkParam: 'item'},
        {name: 'rarity', linkParam: 'item_rarity'},
        {name: 'title', linkParam: 'item_title'},
    ]

    const [baseStats, setBaseStats] = React.useState({});
    const baseStatsFieldsForLink = [
        {name: 'armor', linkParam: 'armor'},
        {name: 'dps', linkParam: 'dps'},
        {name: 'levelRequirement', linkParam: 'level_requirement'},
        {name: 'classRequirement', linkParam: 'class_requirement'},
        {name: 'itemPower', linkParam: 'item_power'},
    ]

    //affixStats heißen im Code öfter mal auch noch itemStats --> mal umbenennen
    const [affixStats, setAffixStats] = React.useState([]);
    const [aspects, setAspects] = React.useState([]);
    const [uniqueAffixes, setUniqueAffixes] = React.useState([])
    const [setAffixes, setSetAffixes] = React.useState([])
    const [mythicAffixes, setMythicAffixes] = React.useState([])

    const [currency, setCurrency] = React.useState({});
    const currencyFieldsForLink = [
        {name: 'type', linkParam: 'currency_type'},
        {name: 'name', linkParam: 'currency'},
    ]

    const [seller, setSeller] = React.useState({});
    const sellerFieldsForLink = [
        {name: 'username', linkParam: 'seller'},
    ]

    const [searchParams, setSearchParams] = useSearchParams();
    const [changedSearchParams, setChangedSearchParams] = React.useState(null);

    React.useEffect(() => {
        updateStatesOrLink(searchParams, setSearchParams, changedSearchParams, setChangedSearchParams, [
            {stateObject: baseItem, setStateObject: setBaseItem, stateObjectFields: baseItemFieldsForLink, isStateArrayOrObject: false},
            {stateObject: baseStats, setStateObject: setBaseStats, stateObjectFields: baseStatsFieldsForLink, isStateArrayOrObject: false},
            {stateObject: affixStats, setStateObject: setAffixStats, stateObjectFields: null, isStateArrayOrObject: true, linkParam: "affix_stats"},
            {stateObject: aspects, setStateObject: setAspects, stateObjectFields: null, isStateArrayOrObject: true, linkParam: "aspects"},
            {stateObject: uniqueAffixes, setStateObject: setUniqueAffixes, stateObjectFields: null, isStateArrayOrObject: true, linkParam: "unique_affixes"},
            {stateObject: setAffixes, setStateObject: setSetAffixes, stateObjectFields: null, isStateArrayOrObject: true, linkParam: "set_affixes"},
            {stateObject: mythicAffixes, setStateObject: setMythicAffixes, stateObjectFields: null, isStateArrayOrObject: true, linkParam: "mythic_affixes"},
            {stateObject: currency, setStateObject: setCurrency, stateObjectFields: currencyFieldsForLink, isStateArrayOrObject: false},
            {stateObject: seller, setStateObject: setSeller, stateObjectFields: sellerFieldsForLink, isStateArrayOrObject: false},
        ])
    }, [baseItem, baseStats, affixStats, aspects, uniqueAffixes, setAffixes, mythicAffixes, currency, seller, searchParams]);

    const overItemsRightElements = [
        <EiaShareButton key={"share-link"} title={"Share search link with filters"}
                        link={window.location.href}
        />
    ]

    return (
        <>
            <Helmet>
                <title>Search – Easy Item Trading</title>
                <link rel="canonical" href={window.location.href} />
                <meta name="description" content="Search - Easy Item Trading - search items, runes, boss materials etc. with filters and sort features"/>
            </Helmet>
            {
                <SearchBasePage
                    user={user}
                    currency={currency} setCurrency={setCurrency}
                    baseItem={baseItem} setBaseItem={setBaseItem}
                    inheritedBaseStats={baseStats} setInheritedBaseStats={setBaseStats}
                    inheritedAffixStats={affixStats} setInheritedAffixStats={setAffixStats}
                    inheritedAspects={aspects} setInheritedAspects={setAspects}
                    inheritedUniqueAffixes={uniqueAffixes} setInheritedUniqueAffixes={setUniqueAffixes}
                    inheritedSetAffixes={setAffixes} setInheritedSetAffixes={setSetAffixes}
                    inheritedMythicAffixes={mythicAffixes} setInheritedMythicAffixes={setMythicAffixes}
                    seller={seller} setSeller={setSeller}
                    onlyBestPricePerItemName={false}
                    activateFiltersDrawer={true}
                    overItemsRightElements={overItemsRightElements}
                />
            }
        </>
    );
}
export default SearchPage;